(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var cartShell = document.querySelector('[data-cart-drawer-shell]');
  var cartBody = document.querySelector('[data-cart-drawer-body]');
  var cartFooter = document.querySelector('[data-cart-drawer-footer]');
  var cartCount = document.querySelector('[data-cart-count]');
  var cartSubtotal = document.querySelector('[data-cart-subtotal]');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchOpeners = document.querySelectorAll('[data-search-open]');
  var searchInput = document.querySelector('[data-search-input]');
  var predictiveResults = document.querySelector('[data-predictive-search-results]');
  var quickViewShell = document.querySelector('[data-quick-view-shell]');
  var quickViewBody = document.querySelector('[data-quick-view-body]');
  var backToTop = document.querySelector('[data-back-to-top]');
  var lastCartTrigger = null;
  var lastSearchTrigger = null;
  var lastQuickViewTrigger = null;
  var cartCloseTimer = null;
  var searchCloseTimer = null;
  var predictiveSearchTimer = null;
  var predictiveSearchController = null;
  var quickViewCloseTimer = null;
  var megaCloseTimer = null;
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function updateAnnouncementOffset() {
    var announcement = document.querySelector('.announcement-bar');
    var height = announcement ? announcement.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-offset', height + 'px');
  }

  function initAnnouncementBar() {
    var announcement = document.querySelector('[data-announcement-bar]');
    if (!announcement) return;
    var key = announcement.getAttribute('data-storage-key');
    if (key && window.localStorage.getItem(key) === 'dismissed') {
      announcement.hidden = true;
      updateAnnouncementOffset();
    }
  }

  function updateBackToTop() {
    if (!backToTop) return;
    backToTop.classList.toggle('is-visible', window.scrollY > 520);
  }

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD'
    }).format(cents / 100);
  }

  function trapFocus(container, event) {
    if (!container || !container.classList.contains('is-open') || event.key !== 'Tab') return;
    var focusable = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function unitPriceText(variant) {
    if (!variant || !variant.unit_price_measurement || !variant.unit_price) return '';
    var measurement = variant.unit_price_measurement;
    return money(variant.unit_price) + ' / ' + measurement.reference_value + measurement.reference_unit;
  }

  function initProductForms(scope) {
    (scope || document).querySelectorAll('[data-product-section]').forEach(function (section) {
      if (section.dataset.productFormReady === 'true') return;
      section.dataset.productFormReady = 'true';
      var data = section.querySelector('[data-product-variants]');
      var select = section.querySelector('[data-variant-select]');
      var input = section.querySelector('[data-variant-input]');
      var price = section.querySelector('[data-current-price]');
      var compare = section.querySelector('[data-compare-price]');
      var unit = section.querySelector('[data-unit-price]');
      var sku = section.querySelector('[data-product-sku]');
      var skuValue = sku ? sku.querySelector('span') : null;
      var addButton = section.querySelector('[data-add-to-cart]');
      var addText = section.querySelector('[data-add-to-cart-text]');
      var status = section.querySelector('[data-variant-status]');
      var variants = [];

      if (!data) return;
      try {
        variants = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }

      function updateVariant(variantId) {
        var variant = variants.find(function (item) {
          return String(item.id) === String(variantId);
        });
        if (!variant) return;

        if (input) input.value = variant.id;
        if (price) price.textContent = money(variant.price);
        if (compare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compare.hidden = false;
            compare.textContent = money(variant.compare_at_price);
          } else {
            compare.hidden = true;
            compare.textContent = '';
          }
        }
        if (unit) {
          var unitText = unitPriceText(variant);
          unit.hidden = !unitText;
          unit.textContent = unitText;
        }
        if (sku && skuValue) {
          sku.hidden = !variant.sku;
          skuValue.textContent = variant.sku || '';
        }
        if (addButton) addButton.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (status) status.textContent = variant.available ? 'In stock' : 'Sold out';
        if (variant.featured_media && variant.featured_media.id) {
          var media = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
          if (media && media.scrollIntoView) {
            media.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
          }
        }
      }

      if (select) {
        select.addEventListener('change', function () {
          updateVariant(select.value);
        });
      }
    });
  }

  function renderCart(cart) {
    if (!cartBody) return;
    if (!cart.items.length) {
      cartBody.innerHTML = '<p>Your cart is empty.</p>';
    } else {
      cartBody.innerHTML = cart.items.map(function (item) {
        var image = item.image
          ? '<img src="' + escapeHTML(item.image) + '&width=160" alt="' + escapeHTML(item.product_title) + '" loading="lazy">'
          : '';
        var properties = item.properties
          ? Object.keys(item.properties).filter(function (key) {
            return key.charAt(0) !== '_' && item.properties[key];
          }).map(function (key) {
            return '<li>' + escapeHTML(key) + ': ' + escapeHTML(item.properties[key]) + '</li>';
          }).join('')
          : '';
        return '<div class="cart-drawer__item">' +
          image +
          '<div><a href="' + escapeHTML(item.url) + '">' + escapeHTML(item.product_title) + '</a>' +
          (item.variant_title ? '<p>' + escapeHTML(item.variant_title) + '</p>' : '') +
          (item.selling_plan_allocation ? '<p>' + escapeHTML(item.selling_plan_allocation.selling_plan.name) + '</p>' : '') +
          (properties ? '<ul class="cart-properties">' + properties + '</ul>' : '') +
          (item.item_components && item.item_components.length ? '<ul class="cart-components">' + item.item_components.map(function (component) {
            return '<li>' + escapeHTML(component.quantity) + ' × ' + escapeHTML(component.title) + '</li>';
          }).join('') + '</ul>' : '') +
          '<p>' + escapeHTML(item.quantity) + ' × ' + escapeHTML(money(item.final_price)) + '</p></div>' +
          '</div>';
      }).join('');
    }
    if (cartCount) cartCount.textContent = cart.item_count;
    if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);
    updateFreeShippingProgress(cart);
  }

  function updateFreeShippingProgress(cart) {
    var progressBlocks = document.querySelectorAll('[data-free-shipping-progress]');
    if (!progressBlocks.length) return;

    var threshold = Number(progressBlocks[0].getAttribute('data-threshold')) || 0;
    if (!threshold || !cart || !cart.items) return;

    var remaining = Math.max(0, threshold - cart.total_price);
    var percentage = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    progressBlocks.forEach(function (block) {
      var message = block.querySelector('[data-free-shipping-message]');
      var bar = block.querySelector('[data-free-shipping-bar]');
      if (message) {
        if (remaining <= 0) {
          message.textContent = block.getAttribute('data-success-text') || '';
        } else {
          var template = block.getAttribute('data-remaining-template') || '';
          message.textContent = template.replace('[amount]', money(remaining));
        }
      }
      if (bar) bar.style.width = percentage + '%';
    });
  }

  function refreshCartDrawerSection() {
    if (!cartShell || !cartBody) return Promise.reject(new Error('Cart drawer missing'));
    var sectionId = cartShell.getAttribute('data-section-id');
    if (!sectionId) return Promise.reject(new Error('Cart section missing'));
    var separator = window.location.pathname.indexOf('?') === -1 ? '?' : '&';
    return fetch(window.location.pathname + separator + 'sections=' + encodeURIComponent(sectionId), {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart section failed');
      return response.json();
    }).then(function (sections) {
      var html = sections[sectionId];
      if (!html) throw new Error('Cart section unavailable');
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var nextBody = parsed.querySelector('[data-cart-drawer-body]');
      var nextFooter = parsed.querySelector('[data-cart-drawer-footer]');
      var nextCount = parsed.querySelector('[data-cart-count]');
      if (nextBody) cartBody.innerHTML = nextBody.innerHTML;
      cartFooter = document.querySelector('[data-cart-drawer-footer]');
      if (cartFooter && nextFooter) cartFooter.innerHTML = nextFooter.innerHTML;
      cartSubtotal = document.querySelector('[data-cart-subtotal]');
      if (cartCount && nextCount) cartCount.textContent = nextCount.textContent;
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (cartCount) cartCount.textContent = cart.item_count;
        if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);
        return refreshCartDrawerSection().catch(function () {
          renderCart(cart);
        }).then(function () {
          return cart;
        });
      });
  }

  function openCart(trigger) {
    if (!cartShell) return;
    window.clearTimeout(cartCloseTimer);
    lastCartTrigger = trigger || document.activeElement;
    cartShell.hidden = false;
    requestAnimationFrame(function () {
      cartShell.classList.add('is-open');
    });
    document.body.classList.add('cart-drawer-open');
    cartOpeners.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'true');
    });
    getCart().finally(function () {
      var closeButton = cartShell.querySelector('button[data-cart-close]');
      if (closeButton) closeButton.focus();
    });
  }

  function closeCart() {
    if (!cartShell) return;
    cartShell.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    cartOpeners.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'false');
    });
    cartCloseTimer = window.setTimeout(function () {
      if (!cartShell.classList.contains('is-open')) cartShell.hidden = true;
    }, 340);
    if (lastCartTrigger && lastCartTrigger.focus) lastCartTrigger.focus();
  }

  function openSearch(trigger) {
    if (!searchPanel) return;
    window.clearTimeout(searchCloseTimer);
    lastSearchTrigger = trigger || document.activeElement;
    searchPanel.hidden = false;
    requestAnimationFrame(function () {
      searchPanel.classList.add('is-open');
    });
    searchOpeners.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'true');
    });
    if (searchInput) {
      window.setTimeout(function () {
        searchInput.focus();
      }, 180);
    }
  }

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-open');
    searchOpeners.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'false');
    });
    searchCloseTimer = window.setTimeout(function () {
      if (!searchPanel.classList.contains('is-open')) searchPanel.hidden = true;
    }, 260);
    if (lastSearchTrigger && lastSearchTrigger.focus) lastSearchTrigger.focus();
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function getPredictiveImage(item) {
    if (!item) return '';
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    if (item.image) return item.image;
    return '';
  }

  function renderPredictiveItem(item, type) {
    var image = getPredictiveImage(item);
    var label = type.charAt(0).toUpperCase() + type.slice(1);
    return '<a class="predictive-search__item" href="' + escapeHTML(item.url) + '">' +
      (image ? '<img src="' + escapeHTML(image) + '&width=120" alt="' + escapeHTML(item.title) + '" loading="lazy">' : '<span class="predictive-search__placeholder" aria-hidden="true"></span>') +
      '<span><strong>' + escapeHTML(item.title) + '</strong><small>' + label + '</small></span>' +
      '</a>';
  }

  function renderPredictiveResults(resources, query) {
    if (!predictiveResults || !searchInput) return;
    var results = resources && resources.results ? resources.results : {};
    var groups = [
      { key: 'products', label: 'Products', type: 'product' },
      { key: 'collections', label: 'Collections', type: 'collection' },
      { key: 'articles', label: 'Articles', type: 'article' },
      { key: 'pages', label: 'Pages', type: 'page' }
    ];
    var html = '';

    groups.forEach(function (group) {
      var items = results[group.key] || [];
      if (!items.length) return;
      html += '<section class="predictive-search__group"><h2>' + group.label + '</h2><div>';
      html += items.map(function (item) {
        return renderPredictiveItem(item, group.type);
      }).join('');
      html += '</div></section>';
    });

    if (!html) {
      html = '<p class="predictive-search__empty">No quick matches for “' + escapeHTML(query) + '”. Press Search to see all results.</p>';
    }

    predictiveResults.innerHTML = html;
    predictiveResults.hidden = false;
    searchInput.setAttribute('aria-expanded', 'true');
  }

  function clearPredictiveResults() {
    if (!predictiveResults) return;
    predictiveResults.innerHTML = '';
    predictiveResults.hidden = true;
    if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
  }

  function fetchPredictiveResults(query) {
    if (!predictiveResults || !query || query.length < 2) {
      clearPredictiveResults();
      return;
    }

    if (predictiveSearchController) predictiveSearchController.abort();
    predictiveSearchController = new AbortController();
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    var params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,collection,article,page',
      'resources[limit]': '4',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.title,vendor'
    });

    fetch(root + 'search/suggest.json?' + params.toString(), {
      headers: { Accept: 'application/json' },
      signal: predictiveSearchController.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Predictive search failed');
      return response.json();
    }).then(function (json) {
      renderPredictiveResults(json.resources, query);
    }).catch(function (error) {
      if (error.name !== 'AbortError') clearPredictiveResults();
    });
  }

  function openQuickView(trigger) {
    if (!quickViewShell || !quickViewBody) return;
    var card = trigger.closest('.product-card');
    var template = card ? card.querySelector('[data-quick-view-template]') : null;
    if (!template) return;

    window.clearTimeout(quickViewCloseTimer);
    lastQuickViewTrigger = trigger;
    quickViewBody.innerHTML = '';
    quickViewBody.appendChild(template.content.cloneNode(true));
    quickViewShell.hidden = false;
    requestAnimationFrame(function () {
      quickViewShell.classList.add('is-open');
    });
    document.body.classList.add('quick-view-open');
    initProductForms(quickViewShell);
    var closeButton = quickViewShell.querySelector('[data-quick-view-close]');
    if (closeButton) closeButton.focus();
  }

  function closeQuickView() {
    if (!quickViewShell) return;
    quickViewShell.classList.remove('is-open');
    document.body.classList.remove('quick-view-open');
    quickViewCloseTimer = window.setTimeout(function () {
      if (!quickViewShell.classList.contains('is-open')) {
        quickViewShell.hidden = true;
        if (quickViewBody) quickViewBody.innerHTML = '';
      }
    }, 260);
    if (lastQuickViewTrigger && lastQuickViewTrigger.focus) lastQuickViewTrigger.focus();
  }

  function padTimer(value) {
    return String(value).padStart(2, '0');
  }

  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (timer) {
      var rawEndDate = timer.getAttribute('data-countdown');
      var endTime = rawEndDate ? new Date(rawEndDate).getTime() : NaN;
      if (!endTime) return;

      var days = timer.querySelector('[data-countdown-days]');
      var hours = timer.querySelector('[data-countdown-hours]');
      var minutes = timer.querySelector('[data-countdown-minutes]');
      var seconds = timer.querySelector('[data-countdown-seconds]');
      var status = timer.parentElement ? timer.parentElement.querySelector('[data-countdown-status]') : null;
      var completeText = timer.getAttribute('data-complete') || '';

      function tick() {
        var distance = endTime - Date.now();
        if (distance <= 0) {
          if (days) days.textContent = '00';
          if (hours) hours.textContent = '00';
          if (minutes) minutes.textContent = '00';
          if (seconds) seconds.textContent = '00';
          if (status && completeText) status.textContent = completeText;
          window.clearInterval(interval);
          return;
        }

        if (days) days.textContent = padTimer(Math.floor(distance / 86400000));
        if (hours) hours.textContent = padTimer(Math.floor((distance % 86400000) / 3600000));
        if (minutes) minutes.textContent = padTimer(Math.floor((distance % 3600000) / 60000));
        if (seconds) seconds.textContent = padTimer(Math.floor((distance % 60000) / 1000));
      }

      tick();
      var interval = window.setInterval(tick, 1000);
    });
  }

  function setZoomOrigin(panel, event) {
    var rect = panel.getBoundingClientRect();
    var x = ((event.clientX - rect.left) / rect.width) * 100;
    var y = ((event.clientY - rect.top) / rect.height) * 100;
    panel.style.setProperty('--zoom-x', Math.min(100, Math.max(0, x)) + '%');
    panel.style.setProperty('--zoom-y', Math.min(100, Math.max(0, y)) + '%');
  }

  function clearLockedZoom(exceptPanel) {
    document.querySelectorAll('[data-product-zoom].is-zoom-locked').forEach(function (panel) {
      if (panel !== exceptPanel) panel.classList.remove('is-zoom-locked', 'is-zooming');
    });
  }

  function initWorkGallerySliders() {
    document.querySelectorAll('[data-work-gallery-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-work-gallery-track]');
      var slides = slider.querySelectorAll('[data-work-gallery-slide]');
      var prev = slider.querySelector('[data-work-gallery-prev]');
      var next = slider.querySelector('[data-work-gallery-next]');
      var delay = Number(slider.getAttribute('data-slide-delay')) || 5000;
      var index = 0;
      var interval = null;

      if (!track || slides.length <= 1) return;

      function goTo(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
      }

      function stop() {
        if (interval) window.clearInterval(interval);
      }

      function start() {
        if (prefersReducedMotion) return;
        stop();
        interval = window.setInterval(function () {
          goTo(index + 1);
        }, delay);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          goTo(index - 1);
          start();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          goTo(index + 1);
          start();
        });
      }

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);

      start();
    });
  }

  function loadProductRecommendations(section) {
    var url = section.getAttribute('data-url');
    if (!url || section.dataset.recommendationsLoaded === 'true') return;
    section.dataset.recommendationsLoaded = 'true';

    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations failed');
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var updatedSection = html.querySelector('[data-product-recommendations]');
        if (!updatedSection || !updatedSection.innerHTML.trim()) {
          section.hidden = true;
          return;
        }
        section.innerHTML = updatedSection.innerHTML;
        if (!section.querySelector('.product-card')) section.hidden = true;
      })
      .catch(function () {
        section.hidden = true;
      });
  }

  function initProductRecommendations() {
    var sections = document.querySelectorAll('[data-product-recommendations]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window) || prefersReducedMotion) {
      sections.forEach(loadProductRecommendations);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        loadProductRecommendations(entry.target);
      });
    }, { rootMargin: '0px 0px 240px 0px' });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  document.querySelectorAll('[data-dismissible]').forEach(function (element) {
    var key = element.getAttribute('data-storage-key');
    if (key && window.localStorage.getItem(key) === 'dismissed') {
      element.hidden = true;
      return;
    }
    element.querySelectorAll('[data-dismiss]').forEach(function (button) {
      button.addEventListener('click', function () {
        element.hidden = true;
        if (key) window.localStorage.setItem(key, 'dismissed');
      });
    });
  });

  document.querySelectorAll('[data-cookie-accept], [data-cookie-decline]').forEach(function (button) {
    button.addEventListener('click', function () {
      var accepted = button.hasAttribute('data-cookie-accept');
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent(accepted, function () {});
      }
      window.localStorage.setItem('rp-cookie-consent-choice', accepted ? 'accepted' : 'declined');
    });
  });

  document.querySelectorAll('[data-popup-delay]').forEach(function (popup) {
    var delay = Number(popup.getAttribute('data-popup-delay')) || 0;
    popup.hidden = true;
    window.setTimeout(function () {
      var key = popup.getAttribute('data-storage-key');
      if (key && window.localStorage.getItem(key) === 'dismissed') return;
      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
      });
      var firstInput = popup.querySelector('input, button, select, textarea, a[href]');
      if (firstInput) firstInput.focus();
    }, delay * 1000);
  });

  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    var summary = accordion.querySelector('[data-accordion-summary]');
    var content = accordion.querySelector('[data-accordion-content]');
    if (!summary || !content) return;

    content.style.overflow = 'hidden';
    content.style.height = accordion.open ? content.scrollHeight + 'px' : '0px';

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      var isOpen = accordion.open;

      if (isOpen) {
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(function () {
          content.style.height = '0px';
          accordion.classList.add('is-closing');
        });
        window.setTimeout(function () {
          accordion.open = false;
          accordion.classList.remove('is-closing');
        }, 320);
      } else {
        accordion.open = true;
        content.style.height = '0px';
        requestAnimationFrame(function () {
          content.style.height = content.scrollHeight + 'px';
        });
      }
    });

    content.addEventListener('transitionend', function () {
      if (accordion.open && !accordion.classList.contains('is-closing')) {
        content.style.height = 'auto';
      }
    });
  });

  document.querySelectorAll('[data-mega-item]').forEach(function (item) {
    var trigger = item.querySelector('[data-mega-trigger]');
    var menu = item.querySelector('[data-mega-menu]');
    if (!trigger || !menu) return;

    function openMega() {
      window.clearTimeout(megaCloseTimer);
      document.querySelectorAll('[data-mega-item].is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          var openTrigger = openItem.querySelector('[data-mega-trigger]');
          var openToggle = openItem.querySelector('[data-submenu-toggle]');
          if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
          if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      var toggle = item.querySelector('[data-submenu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mega-menu-open');
    }

    function closeMega() {
      megaCloseTimer = window.setTimeout(function () {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        var toggle = item.querySelector('[data-submenu-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (!document.querySelector('[data-mega-item].is-open')) {
          document.body.classList.remove('mega-menu-open');
        }
      }, 260);
    }

    item.addEventListener('mouseenter', openMega);
    item.addEventListener('mouseleave', closeMega);
    item.addEventListener('focusin', openMega);
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) closeMega();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      window.clearTimeout(predictiveSearchTimer);
      predictiveSearchTimer = window.setTimeout(function () {
        fetchPredictiveResults(query);
      }, 220);
    });
  }

  updateAnnouncementOffset();
  initAnnouncementBar();
  updateBackToTop();
  initCountdowns();
  initWorkGallerySliders();
  initProductRecommendations();
  initProductForms();
  window.addEventListener('resize', updateAnnouncementOffset);
  window.addEventListener('scroll', updateBackToTop, { passive: true });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      var target = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!target) return;
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      target.hidden = isOpen;
      return;
    }

    var submenuToggle = event.target.closest('[data-submenu-toggle]');
    if (submenuToggle) {
      var submenuItem = submenuToggle.closest('[data-mega-item]');
      if (!submenuItem) return;
      var submenuTrigger = submenuItem.querySelector('[data-mega-trigger]');
      var expanded = submenuToggle.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('[data-mega-item].is-open').forEach(function (openItem) {
        if (openItem !== submenuItem) {
          openItem.classList.remove('is-open');
          var openTrigger = openItem.querySelector('[data-mega-trigger]');
          var openToggle = openItem.querySelector('[data-submenu-toggle]');
          if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
          if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
        }
      });
      submenuToggle.setAttribute('aria-expanded', String(!expanded));
      if (submenuTrigger) submenuTrigger.setAttribute('aria-expanded', String(!expanded));
      submenuItem.classList.toggle('is-open', !expanded);
      return;
    }

    var searchOpener = event.target.closest('[data-search-open]');
    if (searchOpener) {
      event.preventDefault();
      openSearch(searchOpener);
      return;
    }

    if (event.target.closest('[data-search-close]')) {
      clearPredictiveResults();
      closeSearch();
      return;
    }

    var quickViewOpener = event.target.closest('[data-quick-view-open]');
    if (quickViewOpener) {
      event.preventDefault();
      openQuickView(quickViewOpener);
      return;
    }

    if (event.target.closest('[data-quick-view-close]')) {
      closeQuickView();
      return;
    }

    var cartOpener = event.target.closest('[data-cart-open]');
    if (cartOpener) {
      event.preventDefault();
      openCart(cartOpener);
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      closeCart();
      return;
    }

    var announcementDismiss = event.target.closest('[data-announcement-dismiss]');
    if (announcementDismiss) {
      var announcement = announcementDismiss.closest('[data-announcement-bar]');
      if (!announcement) return;
      var announcementKey = announcement.getAttribute('data-storage-key');
      if (announcementKey) window.localStorage.setItem(announcementKey, 'dismissed');
      announcement.classList.add('is-hiding');
      window.setTimeout(function () {
        announcement.hidden = true;
        updateAnnouncementOffset();
      }, 220);
      return;
    }

    var quantityButton = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (quantityButton) {
      var stepper = quantityButton.closest('[data-quantity-stepper]');
      var quantityInput = stepper ? stepper.querySelector('input[name="quantity"]') : null;
      if (!quantityInput) return;
      var min = Number(quantityInput.getAttribute('min')) || 1;
      var max = Number(quantityInput.getAttribute('max')) || Infinity;
      var current = Number(quantityInput.value) || min;
      var direction = quantityButton.matches('[data-quantity-plus]') ? 1 : -1;
      quantityInput.value = Math.min(max, Math.max(min, current + direction));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var zoomPanel = event.target.closest('[data-product-zoom]');
    if (zoomPanel) {
      setZoomOrigin(zoomPanel, event);
      var shouldLock = !zoomPanel.classList.contains('is-zoom-locked');
      clearLockedZoom(zoomPanel);
      zoomPanel.classList.toggle('is-zoom-locked', shouldLock);
      zoomPanel.classList.toggle('is-zooming', shouldLock);
      return;
    }

    var topButton = event.target.closest('[data-back-to-top]');
    if (topButton) {
      window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      return;
    }

    var popupClose = event.target.closest('[data-popup-close]');
    if (popupClose) {
      var popup = popupClose.closest('[data-popup-delay]');
      if (!popup) return;
      popup.classList.remove('is-open');
      window.setTimeout(function () {
        popup.hidden = true;
      }, 240);
      var popupKey = popup.getAttribute('data-storage-key');
      if (popupKey) window.localStorage.setItem(popupKey, 'dismissed');
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form || !window.fetch || !cartShell) return;
    event.preventDefault();
    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart add failed');
      closeQuickView();
      openCart(form.querySelector('[type="submit"]'));
    }).catch(function () {
      form.submit();
    });
  });

  document.addEventListener('keydown', function (event) {
    trapFocus(cartShell, event);
    trapFocus(quickViewShell, event);
    trapFocus(searchPanel, event);
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches && event.target.matches('[data-product-zoom]')) {
      event.preventDefault();
      event.target.click();
      return;
    }
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-menu-toggle][aria-expanded="true"]').forEach(function (toggle) {
      var target = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', 'false');
      if (target) target.hidden = true;
    });
    document.querySelectorAll('[data-mega-item].is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-mega-trigger]');
      var toggle = item.querySelector('[data-submenu-toggle]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('mega-menu-open');
    closeSearch();
    clearPredictiveResults();
    closeQuickView();
    closeCart();
    clearLockedZoom();
  });

  document.addEventListener('pointerenter', function (event) {
    var zoomPanel = event.target.closest && event.target.closest('[data-product-zoom]');
    if (!zoomPanel || event.pointerType !== 'mouse') return;
    zoomPanel.classList.add('is-zooming');
  }, true);

  document.addEventListener('pointermove', function (event) {
    var zoomPanel = event.target.closest && event.target.closest('[data-product-zoom]');
    if (!zoomPanel || (!zoomPanel.classList.contains('is-zooming') && !zoomPanel.classList.contains('is-zoom-locked'))) return;
    setZoomOrigin(zoomPanel, event);
  }, true);

  document.addEventListener('pointerleave', function (event) {
    var zoomPanel = event.target.closest && event.target.closest('[data-product-zoom]');
    if (!zoomPanel || zoomPanel.classList.contains('is-zoom-locked')) return;
    zoomPanel.classList.remove('is-zooming');
  }, true);
})();
